/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Kind_CardInputs */



/**
* | output |
* | --- |
* | "Card" |
*
* @param {Promo_Kind_CardInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_kind_card = /** @type {((inputs?: Promo_Kind_CardInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Kind_CardInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Carte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Carta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carta")
	return /** @type {LocalizedString} */ ("Card")
});